import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import {isPipelinesEnabledInExclusiveMode} from '../../../../../utils/featureToggles'
import {makeResource} from '../../../../../utils/makeResource'

import type {PipelinesBreadcrumbsComponent} from './PipelinesBreadcrumbs'
import {query} from './PipelinesBreadcrumbs.queries'

import {isPipelinesEditScreen, isPipelinesRunScreen} from 'src/routes'
import {queryToObject} from 'src/utils/queryParams'

const PipelinesBreadcrumbsEntryPoint: EntryPoint<
  PipelinesBreadcrumbsComponent,
  LoaderFunctionArgs
> = {
  root: makeResource(
    'PipelineBreadcrumbs',
    () =>
      import(
        /* webpackChunkName: "PipelinesBreadcrumbs" */
        './PipelinesBreadcrumbs'
      ),
  ),
  getPreloadProps({params, request}) {
    const {pipelineId, pipelineRunId} = params
    const url = new URL(request.url)
    const isEditMode = isPipelinesEditScreen(queryToObject(url.search))
    const isPipelineRun = !isEditMode && isPipelinesRunScreen(url.pathname, params)
    const isPipelineRunsList = !isPipelineRun && !isEditMode

    return {
      queries: {
        main: {
          parameters: getRequest(query),
          variables: {
            pipelineLocator: `id:${pipelineId}`,
            pipelineRunLocator: `id:${pipelineRunId}`,
            fetchPipeline: !isPipelinesEnabledInExclusiveMode() || !isPipelineRunsList,
            fetchPipelineRun: isPipelineRun,
          },
        },
      },
      extraProps: {
        isEditMode,
        isPipelineRun,
      },
    }
  },
}
export default PipelinesBreadcrumbsEntryPoint
